import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../Components/Loader";
import PaymentForm from "./PaymentForm";
import AnimationSection from "../../Components/AnimationSection";

const Payment = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const home = await axios.get(
      "https://staging-cms-main.ipurvey.com/homepage"
    );
    setData(home.data);
  }, []);
  if (data)
    return <AnimationSection data={data} forms={<PaymentForm data={data} />} />;
  else return <Loader />;
};

export default Payment;
